import { flushSync } from 'react-dom';
import { constants } from 'app/client/store/reducers/app';

/**
 * @type {Object} The errors that are shown in the banner of the layout, by status. The status of a
 * network error is 0, since there is no response to get a status from.
 */
export const bannerErrors = {
  0: 'core:messages.errors.network',
  429: 'core:messages.errors.rateLimit',
  500: 'core:messages.errors.server',
  502: 'core:messages.errors.server',
  503: 'core:messages.errors.server',
  504: 'core:messages.errors.server',
};

/**
 * Show a dismissible banner with the error message of the given status.
 *
 * @param {number} status The status to show the error message of.
 *
 * @returns {Function} The error action to dispatch.
 */
const setError = (status) => (dispatch) =>
  dispatch({
    type: constants.setError,
    payload: bannerErrors[status],
  });

/**
 * Define actions based on error codes.
 */
export default {
  /**
   * Token expired, so the session is dropped and the login screen takes over.
   */
  401: (dispatch) => {
    // Own commit, so the customer scoped pages unmount first.
    flushSync(() => dispatch({ type: constants.invalidateCustomer }));

    dispatch({
      type: constants.setSessionExpired,
      payload: true,
    });
  },

  /**
   * API rate limit exceeded.
   */
  429: setError(429),

  /**
   * API proxy internal server error.
   */
  500: setError(500),

  /**
   * Database unavailable.
   */
  502: setError(502),

  /**
   * Service unavailable.
   */
  503: setError(503),

  /**
   * Gateway timeout.
   */
  504: setError(504),

  /**
   * No response from server (network timeout, connection refused).
   */
  network: setError(0),
};
